import { create } from 'zustand';

/**
 * Zoom 계정 연결(팝업) 흐름 전용 로딩 오버레이 상태. 앱 전체가 공유하는 useLoadingOverlayStore와
 * 완전히 분리해둔다 — 그걸 같이 썼다가 다른 mutation/query의 setIsLoading(false)가 이 흐름의
 * 오버레이까지 꺼버리는 문제가 있었는데, 공유 스토어에 참조 카운트를 넣는 대신(앱 전역에 영향)
 * Zoom 전용으로 새 스토어를 두는 쪽이 훨씬 안전하다.
 */
type ZoomConnectOverlayState = {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
};

export const useZoomConnectOverlayStore = create<ZoomConnectOverlayState>((set) => ({
  isVisible: false,
  setIsVisible: (isVisible) => set({ isVisible }),
}));
